import React, {useState} from 'react';
import moment from "moment/moment";
import {useForm} from "react-hook-form";
import {Helmet} from "react-helmet";
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import {Form, Tab, Tabs} from "react-bootstrap";
import CustomDatePicker from "../../../base/components/forms/customDatePicker";
import LoadingButton from "../../../base/components/loadingButton";
import BlockUi from "@availity/block-ui";
import axios from "../../../../helpers/axios";
import {Table} from "reactstrap";
import numberFormat from "../../../../helpers/numberFormat";
import {Link} from "react-router-dom";
import {AirBookingEditRoute} from "../../../routesConstants";

const AnalyzeKrs = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [tabIndex, setTabIndex] = useState("main");
  const defaultVal= {
    start: moment().subtract(1, 'months').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY'),
  }
  const formController = useForm({defaultValues:defaultVal})
  const {handleSubmit} = formController

  const submit = async (data) =>{
    setLoading(true)
    const answer = await axios.post('/api/air/airBooking/analyzeKRS', data)
    if(answer?.data?.taskId){
      let attempts = 0;
      const interval = setInterval(async () => {
        attempts++;

        const task = await axios.post('/api/air/airBooking/analyzeKRS/'+answer.data.taskId);
        if (task.data.data.status === "done" || task.data.data.status === "error") {
          setData(task.data.data.result)
          clearInterval(interval);
          setLoading(false)
          return;
        }
        if (attempts >= 24) { // 24 × 5 секунд = 2 минуты
          clearInterval(interval);
          setLoading(false)
          console.log('не удалось получить результат время вышло')
          // показать "Не удалось получить результат"
        }
      }, 5000);
    }

  }
  return (
    <>
      <Helmet><title>Анализ КРС</title></Helmet>
      <BlockUi blocking={loading}>
        <Portlet>
          <PortletHeader title={'Анализ КРС авиабилетов'} toolbar={<PortletHeaderToolbar>
            <form onSubmit={handleSubmit(submit)} className={'d-flex gap-2'}>
              <CustomDatePicker formController={formController}
                                label={"Дата c"}
                                value={defaultVal.start}
                                name={`start`}
                                rules={{required: true}}/>
              <CustomDatePicker formController={formController}
                                label={"Дата по"}
                                value={defaultVal.end}
                                name={`end`}
                                rules={{required: true}}/>
              <LoadingButton loading={loading} title={'Получить'}/>
            </form>
          </PortletHeaderToolbar>}/>
          {data ? <>
          <Tabs
            variant="underline"
            id="controlled-tab-example"
            activeKey={tabIndex}
            className={'ml-2'}
            onSelect={key => {
              setTabIndex(key)
            }}
          >
            <Tab eventKey="main" title="Проблемные">
              <Table bordered>
                <thead>
                <tr>
                  <td>Номер</td>
                  <td>КРС билета</td>
                  <td>Типичная крс</td>
                  <td>Билеты из группы</td>
                  <td>Причина</td>
                </tr>
                </thead>
                <tbody>
                {data?.aiAnswer.results.map((row, index)=>{
                  return <tr key={index}>
                    <td style={{textWrap:'nowrap'}}>{<i className={`fa fa-circle text-${row.status === "attention" ? "warning" : "danger"}`}/>} {row.ticketNumber}</td>
                    <td>{numberFormat(row.currentKRS)}</td>
                    <td>{numberFormat(row.similarSales.typicalKRS)}</td>
                    <td style={{textWrap:'nowrap'}}>{row.similarSales.tickets.map((ticket, index)=>{
                      return <div key={index}>{ticket.ticketNumber} — {numberFormat(ticket.krs)}</div>
                    })}</td>
                    <td>{row.reason}</td>
                  </tr>
                })}
                </tbody>
              </Table>

            </Tab>
            <Tab eventKey="secondary" title="Проверенные группы">
              <Table bordered>
                <thead>
                <tr>
                  <td></td>
                  <td>Типичный крс</td>
                  <td colSpan={2}>Редкий крс</td>
                </tr>
                </thead>
                <tbody>
                {data?.groups.map((group, index)=>{
                  return <React.Fragment key={index}>
                    <tr className={'bg-secondary'}>
                      <td>Группа №{index+1}</td>
                      <td>{group._stats.typicalKRS}</td>
                      <td colSpan={2}>{group._stats.rareValues}</td>
                    </tr>
                    {group.tickets.map((ticket, index)=>{
                      return <tr key={index}>
                        <td>
                          <Link to={AirBookingEditRoute+ticket.bookingId} target={'_blank'}>{ticket.ticketNumber}</Link>
                        </td>
                        <td>{ticket.issueDate}</td>
                        <td>{ticket.krsBuyer}</td>
                        <td>{ticket.segments.map((s,i)=>{
                          return <React.Fragment key={i}>
                            {s.flightClass} | {s.route} {i+1 !== ticket.segments.length ? "; ":""}
                          </React.Fragment>
                        })}</td>
                      </tr>
                    })}
                  </React.Fragment>
                })}
                </tbody>
              </Table>
            </Tab>
          </Tabs>
          </> : <div className={'text-center'}>Время запроса может быть от 35 до 50 секунд из-за времени ответа ИИ</div>}
        </Portlet>
      </BlockUi>
      </>
  );
};

export default AnalyzeKrs;


